
/* injects from baggage-loader */

'use strict';
import moment from 'moment';

/**
 * Filter for show full date time using momment.js.
 *
 * @export
 * @param {shared.module} app
 */
export default function (app) {

	/**
	 * Function that convert date time in moment.js format date (day of week, mount and day, year hours:minutes).
	 */
	function fullDateTimeMoment (){
		return date => date ? moment(date).format('LLLL') : '';
	}

	app.filter('fullDateTimeMoment', fullDateTimeMoment);
}



// WEBPACK FOOTER //
// ./src/app/core/filters/fullDateTimeMoment.filter.js